import { GetApplicationsParams, PostApplication, GetApplicationAuditParams, ApplicationListResponse, ApplicationResponse, ApplicationAuditListResponse } from 'services/security/interfaces/ApplicationInterface';
import { SecurityPathBuilder, SecurityPathsEnum, BuildUrlParams } from 'services/Paths';
import api from 'services/Interceptor';

export const GetApplications = async (params: GetApplicationsParams = {}): Promise<ApplicationListResponse> => {
    let url = `${SecurityPathBuilder(SecurityPathsEnum.Applications)}`;

    const urlParams = BuildUrlParams(params as Record<string, string | string[] | undefined>);
    if (urlParams) {
        url += `?${urlParams}`;
    }

    const { data } = await api.get(url);
    return data;
};



export const PostApplications = async (body: PostApplication): Promise<ApplicationResponse> => {
    const url = SecurityPathBuilder(SecurityPathsEnum.Applications);
    const bodyResponse = {
        ...body,
        workspaceId: 1
    };
    const { data } = await api.post(url, bodyResponse);
    return data;
};

export const UpdateApplications = async (id: number, body: PostApplication): Promise<ApplicationResponse> => {
    const bodyResponse = {
        ...body,
        workspaceId: 1
    };
    const url = `${SecurityPathBuilder(SecurityPathsEnum.Applications)}/${id}`;
    const { data } = await api.put(url, bodyResponse);
    return data;
};

export const DeleteApplications = async (id: number): Promise<ApplicationResponse> => {
    const url = `${SecurityPathBuilder(SecurityPathsEnum.Applications)}/${id}`;
    const response = await api.delete(url);
    return response.data;
};

export const ActivateApplications = async (id: number): Promise<ApplicationResponse> => {
    const url = `${SecurityPathBuilder(SecurityPathsEnum.Applications)}/${id}/activate`;
    const { data } = await api.patch(url);
    return data;
};

export const GetApplicationsAudit = async (params: GetApplicationAuditParams = {}): Promise<ApplicationAuditListResponse> => {
    let url = `${SecurityPathBuilder(SecurityPathsEnum.Applications)}/audit`;
    
    const urlParams = BuildUrlParams(params as Record<string, string | string[] | undefined>);
    if (urlParams) {
        url += `?${urlParams}`;
    }

    const { data } = await api.get(url);
    return data;
};